import { createRendererMotionComponent as i } from "./atoms-v2917.js";
import { isSVGComponent as f } from "./atoms-v21073.js";
import { svgMotionConfig as m } from "./atoms-v21182.js";
import { htmlMotionConfig as c } from "./atoms-v21183.js";
import { createUseRender as p } from "./atoms-v21184.js";
function R(n, r) {
  return function(o, { forwardMotionProps: t } = { forwardMotionProps: !1 }) {
    const e = {
      ...f(o) ? m : c,
      preloadedFeatures: n,
      useRender: p(t),
      createVisualElement: r,
      Component: o
    };
    return i(e);
  };
}
export {
  R as createMotionComponentFactory
};
